import { isAuthenticatedSelector } from 'features/auth/authSlice'
import { TicketCodeForm } from 'features/auth/components/TicketCodePage'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import styled from 'styled-components'
import { colors } from 'utils'
import EleventlyLogo from 'assets/Elevently_logo.png'

const S = {
    PageWrapper: styled.div`
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${colors.pageBackground};
    `,
    FormWrapper: styled.div`
        width: 560px;
        height: 658px;
        padding: 42px 32px 50px 32px;
        background: white;
        box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        overflow: hidden;
    `,
    Image: styled.img`
        width: 100%;
        height: 86px;
        object-fit: contain;
    `,
    Wrapper: styled.div`
        margin-top: 50px;
    `
}

const Login = () => {
    const isLogin = useSelector(isAuthenticatedSelector)

    return isLogin ? <Redirect to="/dashboard" /> :(
        <S.PageWrapper>
            <S.FormWrapper>
                <S.Image src={EleventlyLogo} />
                <S.Wrapper>
                    <TicketCodeForm eventData={{}} />
                </S.Wrapper>
            </S.FormWrapper>
        </S.PageWrapper>
    )
}

export default Login
